import { Injectable } from '@angular/core';
import { LocationSelectorInfo } from 'src/app/admin/user/shared/models/locationSelectorModel';
import { UserSigninStatusModel } from 'src/app/lobby/shared/models/lobby-user-signin-status.model';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  private USERSIGNINSTATEKEY = "USER_SIGN_IN_STATE";
  private LOBBYLOCATIONKEY = "LOBBY_LOCATION_STATE";

  public isSignedIn(): boolean {
    return sessionStorage.getItem(this.USERSIGNINSTATEKEY) != null;
  }

  public setSignInStatus(userSignInStatus: UserSigninStatusModel): void {
    sessionStorage.setItem(this.USERSIGNINSTATEKEY, JSON.stringify(userSignInStatus));
  }

  public getSignInStatus(): UserSigninStatusModel {
    const USERSIGNINSTATE = sessionStorage.getItem(this.USERSIGNINSTATEKEY);
    if (!USERSIGNINSTATE) {
      throw new Error(`Unexpected code path reached! ${this.USERSIGNINSTATEKEY} is not found in session`);
    }
    return JSON.parse(USERSIGNINSTATE);
  }

  public clearSignInSession(): void {
    sessionStorage.removeItem(this.USERSIGNINSTATEKEY);
  }

  public isLobbyLocation(): boolean {
    return sessionStorage.getItem(this.LOBBYLOCATIONKEY) != null;
  }

  public setLobbyLocation(locationSelectorInfo: LocationSelectorInfo): void {
    sessionStorage.setItem(this.LOBBYLOCATIONKEY, JSON.stringify(locationSelectorInfo));
  }

  public getLobbyLocation(): LocationSelectorInfo {
    const LOBBYLOCATIONKEY = sessionStorage.getItem(this.LOBBYLOCATIONKEY);
    if (!LOBBYLOCATIONKEY) {
      throw new Error("Unexpected code path reached!")
    }
    return JSON.parse(LOBBYLOCATIONKEY);
  }

  public clearLobbyLocation(): void {
    sessionStorage.removeItem(this.LOBBYLOCATIONKEY);
  }

}
